// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__3tVlm","matchBlock":"styles_matchBlock__2ctsr","input":"styles_input__15A5e"};